<template>
  <div><home-train :trainTypeList="trainTypeList"></home-train></div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import homeTrain from '@src/components/homeTrain'

@Component({
  components: {
    homeTrain,
  },
})
// 注意修改class名
export default class MyTrain extends Vue {
  @Prop(Array)
  trainTypeList

  created() {
    console.log(this.trainTypeList, '测试')
  }
}
</script>

<style lang="scss" scoped></style>
